import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { components } from "react-select";

const SortableMultiValue = (props) => {
  const ref = useRef(null);
  const [{ handlerId }, drop] = useDrop({
    accept: `MULTI_VALUE_${props.selectProps.fieldName}`,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = props.index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      //console.log("actually move");
      props.selectProps.sortMultiValues(dragIndex, hoverIndex, monitor);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    }
  });
  const [{ isDragging }, drag] = useDrag({
    type: `MULTI_VALUE_${props.selectProps.fieldName}`,
    item: () => {
      return { index: props.index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  const draggingStyles = isDragging
    ? { opacity: 0 }
    : { opacity: 1, cursor: "move", position: "relative" };

  drag(drop(ref));

  const onMouseDown = (e) => {
    e.stopPropagation();
  };
  const innerProps = {
    ...props.innerProps,
    onMouseDown,
    "data-handler-id": handlerId,
    ref,
    style: { ...draggingStyles }
  };

  return <components.MultiValue {...props} innerProps={innerProps} />;
};

export default SortableMultiValue;
